// src/views/pages/user/information-card/cccdValidator.js

export const CCCDValidator = {
    // 1. Kiểm tra quét nhầm mặt
    checkWrongSide(currentSide, payload, qrPayload) {
        const hasFrontData = payload.full_name || qrPayload.full_name || payload.date_of_birth;
        const hasBackData = payload.date_of_issue || qrPayload.date_of_issue || payload.place_of_issue || payload.expiry_date || payload.date_of_expiry;

        if (currentSide === "back" && hasFrontData && !hasBackData) {
            return "Bạn đang tải lên ảnh mặt trước ở chế độ Quét mặt sau. Vui lòng chuyển sang tab mặt trước!";
        }

        if (currentSide === "front" && hasBackData && !hasFrontData) {
            return "Bạn đang tải lên ảnh mặt sau ở chế độ Quét mặt trước. Vui lòng chuyển sang tab mặt sau!";
        }

        return null;
    },

    // 2. Kiểm tra ảnh mặt trước bị mờ / thiếu thông tin
    checkFrontInvalid(currentSide, scannedFullName, scannedIdNumber, scannedDob) {
        if (currentSide === "front" && (!scannedFullName || !scannedIdNumber || !scannedDob)) {
            return "Ảnh mặt trước bị mờ hoặc bị che khuất thông tin. Không thể đọc đủ Họ tên, Số CCCD hoặc Ngày sinh. Vui lòng tải lại ảnh rõ nét!";
        }
        return null;
    },

    // 3. Kiểm tra ảnh mặt sau bị mờ / thiếu thông tin
    checkBackInvalid(currentSide, scannedExpiry, scannedIssueDate) {
        if (currentSide === "back" && (!scannedExpiry || !scannedIssueDate)) {
            return "Ảnh mặt sau bị mờ hoặc không đọc được thông tin Ngày cấp / Ngày hết hạn. Vui lòng tải lại ảnh rõ nét!";
        }
        return null;
    },

    // 4. Kiểm tra đồng nhất số CCCD giữa 2 mặt
    checkIdMismatch(currentSide, scannedIdNumber, frontIdNumber) {
        if (currentSide === "back" && scannedIdNumber && frontIdNumber) {
            if (scannedIdNumber !== frontIdNumber) {
                return "Cảnh báo: Số CCCD ở mặt sau không khớp với mặt trước! Bạn đang quét nhầm thẻ của người khác.";
            }
        }
        return null;
    }
};